export const getRedirectUrl = state => state.redirectsReducer.path;
